function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { useBuildStyleWithTheme } from "../ThemeProvider/index";
import { useMemo } from "react";
var buildStyle = function(iconSize) {
    return function(theme, _dir, param) {
        var typographyUpdates = param.typographyUpdates;
        var svgDefaults = {
            flexShrink: 0,
            position: 'relative',
            top: -1,
            verticalAlign: 'middle',
            marginRight: theme.spacing[2],
            height: "".concat(theme.icon.size[iconSize], " !important"),
            width: "".concat(theme.icon.size[iconSize], " !important")
        };
        return {
            mainContainer: {
                base: _objectSpread({}, carinaFontReset(theme), {
                    color: theme.font.color.interactive.base,
                    appearance: 'none',
                    background: 'none',
                    border: 'none',
                    borderRadius: 0,
                    boxSizing: 'border-box',
                    textDecoration: 'none',
                    cursor: 'pointer',
                    fontSize: 'inherit',
                    fontWeight: theme.font.base.weight.regular,
                    margin: 0,
                    outline: 0,
                    overflow: 'visible',
                    padding: 0,
                    textAlign: 'left',
                    width: 'auto',
                    transitionProperty: 'outline',
                    transitionDuration: theme.animation.duration[100],
                    transitionTimingFunction: theme.animation.productive.easeInOut.easing,
                    '& svg': _objectSpread({}, svgDefaults, {
                        fill: theme.font.color.interactive.base
                    })
                }),
                disabled: {
                    main: {
                        color: theme.font.color.disabled,
                        cursor: 'not-allowed',
                        '& svg': _objectSpread({
                            fill: theme.font.color.disabled
                        }, svgDefaults),
                        '&[aria-disabled]:focus': {
                            outline: "solid ".concat(theme.size.border.focus, "px ").concat(theme.font.color.interactive.disabled),
                            outlineOffset: 4
                        }
                    },
                    isRtl: {
                        '& svg': _objectSpread({}, svgDefaults, {
                            marginLeft: theme.spacing[2],
                            marginRight: 0
                        })
                    }
                },
                isBlock: {
                    main: {
                        display: 'inline-flex',
                        top: 0
                    },
                    hasIcon: {
                        display: 'inline-block'
                    }
                },
                isRtl: {
                    textAlign: 'right',
                    '& svg': _objectSpread({}, svgDefaults, {
                        marginLeft: theme.spacing[2],
                        marginRight: 0
                    })
                },
                isBold: {
                    fontWeight: typographyUpdates ? theme.font.base.weight.medium : theme.font.base.weight.bold
                },
                size: {
                    s: {
                        fontSize: theme.font.base.size.xxs
                    },
                    m: {
                        fontSize: theme.font.base.size.s
                    },
                    l: {
                        fontSize: theme.font.base.size.m
                    }
                },
                states: {
                    '&:hover': {
                        color: theme.font.color.interactive.hover,
                        textDecoration: 'underline',
                        '& svg': {
                            fill: theme.font.color.interactive.hover
                        }
                    },
                    '&:focus': {
                        outline: "solid ".concat(theme.size.border.focus, "px ").concat(theme.font.color.interactive.focus),
                        outlineOffset: 4
                    },
                    '&:active': {
                        color: theme.font.color.interactive.active,
                        '& svg': {
                            fill: theme.font.color.interactive.active
                        }
                    }
                }
            },
            variants: {
                neutral: {
                    base: {
                        color: theme.font.color.base,
                        '& svg': _objectSpread({
                            fill: theme.font.color.base
                        }, svgDefaults),
                        textDecoration: 'underline'
                    },
                    states: {
                        '&:hover': {
                            color: theme.font.color.hover,
                            '& svg': _objectSpread({
                                fill: theme.font.color.hover
                            }, svgDefaults)
                        },
                        '&:focus': {
                            outline: "solid ".concat(theme.size.border.focus, "px ").concat(theme.font.color.focus),
                            outlineOffset: 4
                        },
                        '&:active': {
                            color: theme.font.color.active,
                            '& svg': _objectSpread({
                                fill: theme.font.color.active
                            }, svgDefaults)
                        }
                    },
                    isRtl: {
                        '& svg': _objectSpread({}, svgDefaults, {
                            marginLeft: theme.spacing[2],
                            marginRight: 0
                        })
                    },
                    disabled: {
                        '& svg': _objectSpread({
                            fill: theme.font.color.disabled
                        }, svgDefaults)
                    },
                    disabledIsRtl: {
                        '& svg': _objectSpread({}, svgDefaults, {
                            marginLeft: theme.spacing[2],
                            marginRight: 0
                        })
                    }
                },
                warning: {
                    base: {
                        color: theme.font.color.warning.fill,
                        '& svg': _objectSpread({
                            fill: theme.font.color.warning.fill
                        }, svgDefaults),
                        textDecoration: 'underline'
                    },
                    states: {
                        '&:hover': {
                            color: theme.font.color.warning.fill,
                            '& svg': _objectSpread({
                                fill: theme.font.color.warning.fill
                            }, svgDefaults)
                        },
                        '&:focus': {
                            outline: "solid ".concat(theme.size.border.focus, "px ").concat(theme.font.color.warning.focus),
                            outlineOffset: 4
                        },
                        '&:active': {
                            color: theme.font.color.warning.fill,
                            '& svg': _objectSpread({
                                fill: theme.font.color.warning.fill
                            }, svgDefaults)
                        }
                    },
                    isRtl: {
                        '& svg': _objectSpread({}, svgDefaults, {
                            marginLeft: theme.spacing[2],
                            marginRight: 0
                        })
                    },
                    disabled: {
                        '& svg': _objectSpread({
                            fill: theme.font.color.warning.disabled
                        }, svgDefaults)
                    },
                    disabledIsRtl: {
                        '& svg': _objectSpread({}, svgDefaults, {
                            marginLeft: theme.spacing[2],
                            marginRight: 0
                        })
                    }
                },
                brand: {
                    base: {
                        color: theme.font.color.brand.fill,
                        '& svg': _objectSpread({
                            fill: theme.font.color.brand.fill
                        }, svgDefaults),
                        textDecoration: 'underline'
                    },
                    states: {
                        '&:hover': {
                            color: theme.font.color.brand.fill,
                            '& svg': _objectSpread({
                                fill: theme.font.color.brand.fill
                            }, svgDefaults)
                        },
                        '&:focus': {
                            outline: "solid ".concat(theme.size.border.focus, "px ").concat(theme.font.color.brand.fill),
                            outlineOffset: 4
                        },
                        '&:active': {
                            color: theme.font.color.brand.fill,
                            '& svg': _objectSpread({
                                fill: theme.font.color.brand.fill
                            }, svgDefaults)
                        }
                    },
                    isRtl: {
                        '& svg': _objectSpread({}, svgDefaults, {
                            marginLeft: theme.spacing[2],
                            marginRight: 0
                        })
                    },
                    disabled: {
                        '& svg': _objectSpread({
                            fill: theme.font.color.brand.fill
                        }, svgDefaults)
                    },
                    disabledIsRtl: {
                        '& svg': _objectSpread({}, svgDefaults, {
                            marginLeft: theme.spacing[2],
                            marginRight: 0
                        })
                    }
                },
                accent: {
                    base: {
                        color: theme.font.color.base,
                        textDecoration: 'underline',
                        '& svg': _objectSpread({
                            fill: theme.font.color.base
                        }, svgDefaults)
                    },
                    states: {
                        '&:hover': {
                            color: theme.font.color.base,
                            '& svg': _objectSpread({
                                fill: theme.font.color.base
                            }, svgDefaults)
                        },
                        '&:focus': {
                            outline: "solid ".concat(theme.size.border.focus, "px ").concat(theme.font.color.base),
                            outlineOffset: 4
                        },
                        '&:active': {
                            color: theme.font.color.base,
                            '& svg': _objectSpread({
                                fill: theme.font.color.base
                            }, svgDefaults)
                        }
                    },
                    isRtl: {
                        '& svg': _objectSpread({}, svgDefaults, {
                            marginLeft: theme.spacing[2],
                            marginRight: 0
                        })
                    },
                    disabled: {
                        '& svg': _objectSpread({
                            fill: theme.font.color.base
                        }, svgDefaults)
                    },
                    disabledIsRtl: {
                        '& svg': _objectSpread({}, svgDefaults, {
                            marginLeft: theme.spacing[2],
                            marginRight: 0
                        })
                    }
                },
                tertiary: {
                    base: {
                        color: theme.font.color.tertiary.fill,
                        textDecoration: 'underline',
                        '& svg': _objectSpread({
                            fill: theme.font.color.tertiary.fill
                        }, svgDefaults)
                    },
                    states: {
                        '&:hover': {
                            color: theme.font.color.tertiary.fill,
                            '& svg': _objectSpread({
                                fill: theme.font.color.tertiary.fill
                            }, svgDefaults)
                        },
                        '&:focus': {
                            outline: "solid ".concat(theme.size.border.focus, "px ").concat(theme.font.color.tertiary.fill),
                            outlineOffset: 4
                        },
                        '&:active': {
                            color: theme.font.color.tertiary.fill,
                            '& svg': _objectSpread({
                                fill: theme.font.color.tertiary.fill
                            }, svgDefaults)
                        }
                    },
                    isRtl: {
                        '& svg': _objectSpread({}, svgDefaults, {
                            marginLeft: theme.spacing[2],
                            marginRight: 0
                        })
                    },
                    disabled: {
                        '& svg': _objectSpread({
                            fill: theme.font.color.tertiary.fill
                        }, svgDefaults)
                    },
                    disabledIsRtl: {
                        '& svg': _objectSpread({}, svgDefaults, {
                            marginLeft: theme.spacing[2],
                            marginRight: 0
                        })
                    }
                },
                danger: {
                    base: {
                        color: theme.font.color.danger.fill,
                        textDecoration: 'underline',
                        '& svg': _objectSpread({
                            fill: theme.font.color.danger.fill
                        }, svgDefaults)
                    },
                    states: {
                        '&:hover': {
                            color: theme.font.color.danger.fill,
                            '& svg': _objectSpread({
                                fill: theme.font.color.danger.fill
                            }, svgDefaults)
                        },
                        '&:focus': {
                            outline: "solid ".concat(theme.size.border.focus, "px ").concat(theme.font.color.danger.fill),
                            outlineOffset: 4
                        },
                        '&:active': {
                            color: theme.font.color.danger.fill,
                            '& svg': _objectSpread({
                                fill: theme.font.color.danger.fill
                            }, svgDefaults)
                        }
                    },
                    isRtl: {
                        '& svg': _objectSpread({}, svgDefaults, {
                            marginLeft: theme.spacing[2],
                            marginRight: 0
                        })
                    },
                    disabled: {
                        '& svg': _objectSpread({
                            fill: theme.font.color.danger.fill
                        }, svgDefaults)
                    },
                    disabledIsRtl: {
                        '& svg': _objectSpread({}, svgDefaults, {
                            marginLeft: theme.spacing[2],
                            marginRight: 0
                        })
                    }
                },
                success: {
                    base: {
                        color: theme.font.color.success.fill,
                        textDecoration: 'underline',
                        '& svg': _objectSpread({
                            fill: theme.font.color.success.fill
                        }, svgDefaults)
                    },
                    states: {
                        '&:hover': {
                            color: theme.font.color.success.fill,
                            '& svg': _objectSpread({
                                fill: theme.font.color.success.fill
                            }, svgDefaults)
                        },
                        '&:focus': {
                            outline: "solid ".concat(theme.size.border.focus, "px ").concat(theme.font.color.success.fill),
                            outlineOffset: 4
                        },
                        '&:active': {
                            color: theme.font.color.success.fill,
                            '& svg': _objectSpread({
                                fill: theme.font.color.success.fill
                            }, svgDefaults)
                        }
                    },
                    isRtl: {
                        '& svg': _objectSpread({}, svgDefaults, {
                            marginLeft: theme.spacing[2],
                            marginRight: 0
                        })
                    },
                    disabled: {
                        '& svg': _objectSpread({
                            fill: theme.font.color.success.fill
                        }, svgDefaults)
                    },
                    disabledIsRtl: {
                        '& svg': _objectSpread({}, svgDefaults, {
                            marginLeft: theme.spacing[2],
                            marginRight: 0
                        })
                    }
                },
                interactive: {
                    base: {
                        color: theme.font.color.interactive.fill,
                        textDecoration: 'underline',
                        '& svg': _objectSpread({
                            fill: theme.font.color.interactive.fill
                        }, svgDefaults)
                    },
                    states: {
                        '&:hover': {
                            color: theme.font.color.interactive.fill,
                            '& svg': _objectSpread({
                                fill: theme.font.color.interactive.fill
                            }, svgDefaults)
                        },
                        '&:focus': {
                            outline: "solid ".concat(theme.size.border.focus, "px ").concat(theme.font.color.interactive.fill),
                            outlineOffset: 4
                        },
                        '&:active': {
                            color: theme.font.color.interactive.fill,
                            '& svg': _objectSpread({
                                fill: theme.font.color.interactive.fill
                            }, svgDefaults)
                        }
                    },
                    isRtl: {
                        '& svg': _objectSpread({}, svgDefaults, {
                            marginLeft: theme.spacing[2],
                            marginRight: 0
                        })
                    },
                    disabled: {
                        '& svg': _objectSpread({
                            fill: theme.font.color.interactive.fill
                        }, svgDefaults)
                    },
                    disabledIsRtl: {
                        '& svg': _objectSpread({}, svgDefaults, {
                            marginLeft: theme.spacing[2],
                            marginRight: 0
                        })
                    }
                }
            }
        };
    };
};
function carinaFontReset(theme) {
    return {
        fontFamily: theme.font.base.family,
        fontStyle: 'normal',
        fontWeight: theme.font.base.weight.regular,
        lineHeight: theme.font.lineHeight.base,
        letterSpacing: 'normal',
        textIndent: 0,
        textShadow: 'none',
        textTransform: 'none'
    };
}
var useStyle = function(param) {
    var disabled = param.disabled, isBlock = param.isBlock, isRtl = param.isRtl, icon = param.icon, iconSize = param.iconSize, size = param.size, bold = param.bold, neutral = param.neutral, variant = param.variant;
    var styles = useBuildStyleWithTheme(buildStyle(iconSize));
    return useMemo(function() {
        if (styles) {
            var mainContainer = styles.mainContainer, variants = styles.variants;
            return {
                mainContainer: _objectSpread({}, mainContainer.base, isRtl && mainContainer.isRtl, disabled ? mainContainer.disabled.main : mainContainer.states, disabled && isRtl && mainContainer.disabled.isRtl, isBlock && _objectSpread({}, mainContainer.isBlock.main, icon && mainContainer.isBlock.hasIcon), bold && mainContainer.isBold, size && mainContainer.size[size], neutral && _objectSpread({}, variants.neutral.base, !disabled ? variants.neutral.states : variants.neutral.disabled, isRtl && variants.neutral.isRtl, isRtl && disabled && variants.neutral.disabledIsRtl), variant && _objectSpread({}, variants[variant].base, !disabled ? variants[variant].states : variants[variant].disabled, isRtl && variants[variant].isRtl, isRtl && disabled && variants[variant].disabledIsRtl))
            };
        }
        return {};
    }, [
        bold,
        disabled,
        icon,
        isBlock,
        isRtl,
        neutral,
        size,
        styles,
        variant
    ]);
};
export { useStyle };
